import React, { useEffect } from "react";
import getDisplayName from "./getDisplayName";
import { selector } from "../redux/helpers/selector";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/marketing";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import LearnMore from "../../../../components/learnMore/learnMore";
import ErrorBoundary from "../../../../components/errorBoundary/errorBoundary";

const { fetchData } = actionCreators;
const withSectionToggle = (
  WrappedComponent,
  { moduleName, params, height, chartContentTitle = "Undefined", chartContent = null, ...rest }
) => {
  const state = selector(moduleName);
  const NewComponent = () => {
    const dispatch = useDispatch();
    const { isLoading } = useSelector(state);
    const componentProps = { state, moduleName };

    useEffect(() => {
      dispatch(fetchData({ moduleName, params, constants: rest }));
    }, []);

    return (
      <SectionToggle
        isLoading={isLoading}
        height={height}
        autoHeight={!height}
        title={chartContentTitle}
        content={
          <ErrorBoundary {...params.notifications} moduleName={moduleName + "Module"}>
            <WrappedComponent {...componentProps} />
          </ErrorBoundary>
        }
        learnMore={
          chartContent && <LearnMore content={chartContent} title={chartContentTitle} html />
        }
      />
    );
  };

  NewComponent.displayName = `WrappedComponent(${getDisplayName(WrappedComponent)})`;

  return NewComponent;
};

export default withSectionToggle;
